import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs';
import { UtilsService } from './utils.service';

@Injectable({
  providedIn: 'root'
})
export class MyReviewsService {

  constructor(public http: HttpClient, public utils: UtilsService) { }

  getUserReview(type: any) {
    return this.http.post(`${this.utils.apiUrl}CustomerConsultation/GetMyReviews`, {
      pageSize: 10,
      pageNumber: 0,
      type: type
    })
      .pipe(catchError(this.utils.processError.bind(this)))
  }

  deleteReview(data: any) {
    let url = `${this.utils.apiUrl}CustomerConsultation/DeleteProductReview?reviewGuidId=${data}`
    return this.http.post(url, {})
  }
}
